import script from "./ManutOsExecucaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsExecucaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsExecucaoPage.vue?vue&type=style&index=0&id=4a4edc52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4edc52"]])

export default __exports__